import React from "react";
import cropr from "../../shared/utils/cropr";
import { gettext } from "../../shared/utils/legacy";
import "./Dashboard.scss";
import TimeLineTile from "./TimeLineTile";
import WeatherTile from "./WeatherTile";
import UpgradeTile from "./UpgradeTile";
import DashboardCostsTile from "./costs/DashboardCostsTile";

// BETA dashboard. Todo remove
const Dashboard = () => {
  return (
    <>
      <div className="alert alert-info d-flex justify-content-center m-0 b-r-0 ">
        <h5 className="mr-auto">Bèta dashboard</h5>
      </div>
      <div className="dashboard-top ">
        <div className="ml-3">
          <figure className="p-1">
            <a href="/cropr/settings/farm/">
              <img
                src={cropr.farm.get("avatar")}
                alt={gettext("Avatar for Farm")}
                className="dashboard-avatar mr-2"
              />
            </a>
          </figure>
          <div>
            <h2>{`${gettext("Welcome")} ${cropr.user.name}`}</h2>
            <em>
              <i className="icn_farm pr-2" />
              {cropr.farm.get("name")}
            </em>
          </div>
        </div>
      </div>
      <div className="row m-1 mt-2">
        <div className="col">
          {/*//todo if you dont have a plan yet, show below tile (check show_plan_warning in old view)*/}
          {/*<div className="mb-3">*/}
          {/*  <NoPlanTile />*/}
          {/*</div>*/}
          <div className="row ">
            <div className="col">
              <DashboardCostsTile />
            </div>
            <div className="col">
              <WeatherTile />
            </div>
          </div>
        </div>
        <div className="col-4">
          <TimeLineTile />
          {!cropr.features.pro && !cropr.features.premium && <UpgradeTile />}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
